/**
 * Members Area JavaScript functionality - Pure JavaScript (No jQuery)
 */

(function() {
'use strict';

// SignaturePad is loaded externally via CDN to avoid global scope conflicts
// The global 'SignaturePad' variable is available from the UMD build

// Global signature pad instance
let signaturePad = null;

// Initialize when DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMembersArea);
} else {
    initMembersArea();
}

function initMembersArea() {
    // Tab switching for login/register
    const tabButtons = document.querySelectorAll('.gdcm-tab-button');
    tabButtons.forEach(button => {
        button.addEventListener('click', function() {
            const tabName = this.getAttribute('data-tab');
            switchTab(tabName);
        });
    });
    
    // Dashboard tab switching
    const dashboardTabs = document.querySelectorAll('.gdcm-dashboard-tab');
    dashboardTabs.forEach(tab => {
        tab.addEventListener('click', function() {
            const tabName = this.getAttribute('data-tab');
            switchDashboardTab(tabName);
        });
    });
    
    // Form submissions
    const loginForm = document.getElementById('gdcm-member-login-form');
    if (loginForm) {
        loginForm.addEventListener('submit', handleLogin);
    }
    
    const registerForm = document.getElementById('gdcm-member-register-form');
    if (registerForm) {
        registerForm.addEventListener('submit', handleRegister);
    }
    
    const profileForm = document.getElementById('gdcm-update-profile-form');
    if (profileForm) {
        profileForm.addEventListener('submit', handleProfileUpdate);
    }
    
    // Logout button
    const logoutButton = document.getElementById('gdcm-member-logout');
    if (logoutButton) {
        logoutButton.addEventListener('click', handleLogout);
    }
    
    // Claim coupon button
    const claimCouponButton = document.getElementById('gdcm-claim-coupon');
    if (claimCouponButton) {
        claimCouponButton.addEventListener('click', handleClaimCoupon);
    }
    
    // Password confirmation validation
    const confirmPasswordField = document.getElementById('register-confirm-password');
    if (confirmPasswordField) {
        confirmPasswordField.addEventListener('input', validatePasswordMatch);
    }
    
    // Entry Waiver form handling
    initWaiverForm();
}

function switchTab(tabName) {
    // Update tab buttons
    const tabButtons = document.querySelectorAll('.gdcm-tab-button');
    tabButtons.forEach(button => {
        button.classList.remove('active');
    });
    
    const activeButton = document.querySelector(`.gdcm-tab-button[data-tab="${tabName}"]`);
    if (activeButton) {
        activeButton.classList.add('active');
    }
    
    // Update tab content
    const tabContents = document.querySelectorAll('.gdcm-tab-content');
    tabContents.forEach(content => {
        content.classList.remove('active');
    });
    
    const activeContent = document.getElementById(`gdcm-${tabName}-form`);
    if (activeContent) {
        activeContent.classList.add('active');
    }
}

function switchDashboardTab(tabName) {
    // Update tab buttons
    const dashboardTabs = document.querySelectorAll('.gdcm-dashboard-tab');
    dashboardTabs.forEach(tab => {
        tab.classList.remove('active');
    });
    
    const activeTab = document.querySelector(`.gdcm-dashboard-tab[data-tab="${tabName}"]`);
    if (activeTab) {
        activeTab.classList.add('active');
    }
    
    // Update tab content
    const dashboardContents = document.querySelectorAll('.gdcm-dashboard-content');
    dashboardContents.forEach(content => {
        content.classList.remove('active');
    });
    
    const activeContent = document.getElementById(`gdcm-tab-${tabName}`);
    if (activeContent) {
        activeContent.classList.add('active');
        
        // Initialize calendar when calendar tab is accessed
        if (tabName === 'calendar') {
            initializeCalendarTab();
        }
        
        // Resize signature canvas when waiver tab is accessed
        // (canvas needs to be visible to calculate correct dimensions)
        if (tabName === 'waiver' || tabName === 'entry-waiver') {
            setTimeout(() => {
                resizeSignatureCanvas();
            }, 50);
        }
    }
}

function initializeCalendarTab() {
    // Small delay to ensure the tab content is visible
    setTimeout(() => {
        // Look for calendar elements specifically within the member dashboard
        const memberDashboard = document.getElementById('gdcm-member-dashboard');
        if (!memberDashboard) return;
        
        const calendarElements = memberDashboard.querySelectorAll('#gdcm-frontend-calendar, .gdcm-frontend-calendar');
        
        calendarElements.forEach((calendarEl) => {
            if (calendarEl && !calendarEl.hasAttribute('data-calendar-initialized')) {
                // Mark as initialized to avoid double initialization
                calendarEl.setAttribute('data-calendar-initialized', 'true');
                
                // Generate unique ID if needed
                if (!calendarEl.id) {
                    calendarEl.id = 'gdcm-frontend-calendar-' + Math.random().toString(36).substr(2, 9);
                }
                
                initializeSingleCalendar(calendarEl);
            }
        });
    }, 100);
}

function initializeSingleCalendar(calendarEl) {
    if (!window.GDCMCalendar) {
        console.warn('GDCMCalendar not available for member dashboard calendar');
        return;
    }
    
    try {
        // Create a new calendar instance for this specific element
        const calendar = new window.GDCMCalendar(calendarEl, {
            initialView: 'dayGridMonth',
            headerToolbar: {
                left: 'prev,next,today',
                center: 'title',
                right: 'dayGridMonth,listWeek'
            },
            events: (info, successCallback, failureCallback) => {
                // Load events from REST API
                if (window.gdcmData && window.gdcmData.root) {
                    fetch(window.gdcmData.root + 'events')
                        .then(response => {
                            if (!response.ok) {
                                throw new Error('Network response was not ok');
                            }
                            return response.json();
                        })
                        .then(events => {
                            // Filter events if needed for member view
                            const filteredEvents = events.filter(event => {
                                // Show only future events or events from last 30 days
                                const eventDate = new Date(event.start);
                                const thirtyDaysAgo = new Date();
                                thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);
                                return eventDate >= thirtyDaysAgo;
                            });
                            successCallback(filteredEvents);
                        })
                        .catch(error => {
                            console.error('Member calendar error loading events:', error);
                            // Show empty calendar instead of failing
                            successCallback([]);
                        });
                } else {
                    console.warn('gdcmData not available, showing empty calendar');
                    successCallback([]);
                }
            },
            eventClick: (info) => {
                // Use the same booking modal as the main calendar
                if (window.GDCMFrontend && typeof window.GDCMFrontend.showBookingModal === 'function') {
                    console.log('Member calendar: Using main booking modal');
                    window.GDCMFrontend.showBookingModal(info.event);
                } else {
                    console.log('Member calendar: Main booking modal not available, using fallback');
                    // Fallback: show member event details if main frontend not available
                    showMemberEventDetails(info.event);
                }
            },
            eventDidMount: (info) => {
                // Add custom classes for member dashboard styling
                const eventType = info.event.extendedProps.type || 'class';
                info.el.classList.add(`gdcm-event-${eventType}`);
                info.el.classList.add('gdcm-member-event');
                
                // Add tooltip
                const tooltip = getMemberEventTooltip(info.event);
                info.el.setAttribute('title', tooltip);
            },
            height: 'auto',
            aspectRatio: 1.8
        });
        
        calendar.render();
        
        // Store calendar instance on the element for potential future reference
        calendarEl._gdcmCalendar = calendar;
        
    } catch (error) {
        console.error('Error initializing member dashboard calendar:', error);
    }
}

function showMemberEventDetails(event) {
    // Create a simple modal for member event details
    const modal = document.createElement('div');
    modal.className = 'gdcm-modal gdcm-member-event-modal';
    modal.innerHTML = `
        <div class="gdcm-modal-content">
            <div class="gdcm-modal-header">
                <h3 class="gdcm-modal-title">${event.title}</h3>
                <button type="button" class="gdcm-modal-close" onclick="this.closest('.gdcm-modal').remove()">×</button>
            </div>
            <div class="gdcm-modal-body">
                <div class="tw-space-y-4">
                    <div>
                        <strong>Date & Time:</strong><br>
                        ${new Date(event.start).toLocaleDateString()} at ${new Date(event.start).toLocaleTimeString()}
                    </div>
                    ${event.extendedProps.description ? `
                        <div>
                            <strong>Description:</strong><br>
                            ${event.extendedProps.description}
                        </div>
                    ` : ''}
                    <div class="tw-text-center tw-mt-6">
                        <div class="gdcm-booking-info tw-bg-blue-50 tw-p-4 tw-rounded-lg">
                            <p class="tw-text-sm tw-text-blue-800">This event is available for booking. Please refresh the page if the booking interface is not loading properly.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    `;
    
    document.body.appendChild(modal);
    
    // Close modal when clicking outside
    modal.addEventListener('click', (e) => {
        if (e.target === modal) {
            modal.remove();
        }
    });
}

function getMemberEventTooltip(event) {
    const date = new Date(event.start).toLocaleDateString();
    const time = new Date(event.start).toLocaleTimeString();
    return `${event.title} - ${date} at ${time}`;
}

function handleLogin(e) {
    e.preventDefault();
    
    const form = e.target;
    const submitBtn = form.querySelector('button[type="submit"]');
    const originalText = submitBtn.textContent;
    
    // Disable form and show loading
    submitBtn.disabled = true;
    submitBtn.textContent = 'Logging in...';
    
    const formData = new FormData();
    formData.append('action', 'gdcm_member_login');
    formData.append('nonce', gdcm_members_ajax.nonce);
    formData.append('email', form.querySelector('#login-email').value);
    formData.append('password', form.querySelector('#login-password').value);
    
    fetch(gdcm_members_ajax.ajax_url, {
        method: 'POST',
        body: formData
    })
    .then(response => response.json())
    .then(data => {
        if (data.success) {
            showMessage(gdcm_members_ajax.messages.login_success, 'success');
            
            // Load member dashboard immediately without delay
            loadMemberDashboard();
        } else {
            // Handle error message properly
            let errorMessage = gdcm_members_ajax.messages.login_error;
            if (data.data && typeof data.data === 'string') {
                errorMessage = data.data;
            }
            showMessage(errorMessage, 'error');
        }
    })
    .catch(error => {
        console.error('Login error:', error);
        showMessage(gdcm_members_ajax.messages.login_error, 'error');
    })
    .finally(() => {
        submitBtn.disabled = false;
        submitBtn.textContent = originalText;
    });
}

function handleRegister(e) {
    e.preventDefault();
    
    const form = e.target;
    const submitBtn = form.querySelector('button[type="submit"]');
    const originalText = submitBtn.textContent;
    
    // Validate passwords match
    const password = form.querySelector('#register-password').value;
    const confirmPassword = form.querySelector('#register-confirm-password').value;
    
    if (password !== confirmPassword) {
        showMessage('Passwords do not match.', 'error');
        return;
    }
    
    // Disable form and show loading
    submitBtn.disabled = true;
    submitBtn.textContent = 'Registering...';
    
    const formData = new FormData();
    formData.append('action', 'gdcm_member_register');
    formData.append('nonce', gdcm_members_ajax.nonce);
    formData.append('name', form.querySelector('#register-name').value);
    formData.append('email', form.querySelector('#register-email').value);
    formData.append('phone', form.querySelector('#register-phone').value);
    formData.append('password', password);
    formData.append('confirm_password', confirmPassword);
    
    fetch(gdcm_members_ajax.ajax_url, {
        method: 'POST',
        body: formData
    })
    .then(response => response.json())
    .then(data => {
        if (data.success) {
            showMessage(gdcm_members_ajax.messages.register_success, 'success');
            
            // Clear form
            form.reset();
            
            // Switch to login tab
            setTimeout(() => {
                switchTab('login');
            }, 2000);
        } else {
            showMessage(data.data || gdcm_members_ajax.messages.register_error, 'error');
        }
    })
    .catch(error => {
        console.error('Register error:', error);
        showMessage(gdcm_members_ajax.messages.register_error, 'error');
    })
    .finally(() => {
        submitBtn.disabled = false;
        submitBtn.textContent = originalText;
    });
}

function handleProfileUpdate(e) {
    e.preventDefault();
    
    const form = e.target;
    const submitBtn = form.querySelector('button[type="submit"]');
    const originalText = submitBtn.textContent;
    
    // Disable form and show loading
    submitBtn.disabled = true;
    submitBtn.textContent = 'Updating...';
    
    const formData = new FormData();
    formData.append('action', 'gdcm_update_member_profile');
    formData.append('nonce', gdcm_members_ajax.nonce);
    formData.append('name', form.querySelector('#profile-name').value);
    formData.append('email', form.querySelector('#profile-email').value);
    formData.append('phone', form.querySelector('#profile-phone').value);
    
    // Only include password if provided
    const newPassword = form.querySelector('#profile-new-password');
    if (newPassword && newPassword.value) {
        formData.append('new_password', newPassword.value);
    }
    
    fetch(gdcm_members_ajax.ajax_url, {
        method: 'POST',
        body: formData
    })
    .then(response => response.json())
    .then(data => {
        if (data.success) {
            showDashboardMessage(gdcm_members_ajax.messages.profile_updated, 'success');
            
            // Clear password field
            if (newPassword) {
                newPassword.value = '';
            }
        } else {
            showDashboardMessage(data.data || 'Error updating profile.', 'error');
        }
    })
    .catch(error => {
        console.error('Profile update error:', error);
        showDashboardMessage('Error updating profile.', 'error');
    })
    .finally(() => {
        submitBtn.disabled = false;
        submitBtn.textContent = originalText;
    });
}

function handleLogout(e) {
    e.preventDefault();
    
    const formData = new FormData();
    formData.append('action', 'gdcm_member_logout');
    formData.append('nonce', gdcm_members_ajax.nonce);
    
    fetch(gdcm_members_ajax.ajax_url, {
        method: 'POST',
        body: formData
    })
    .then(response => response.json())
    .then(data => {
        if (data.success) {
            // Reload the page to show login form
            window.location.reload();
        } else {
            showDashboardMessage('Error logging out.', 'error');
        }
    })
    .catch(error => {
        console.error('Logout error:', error);
        showDashboardMessage('Error logging out.', 'error');
    });
}

function handleClaimCoupon(e) {
    e.preventDefault();
    
    const button = e.target;
    const originalText = button.textContent;
    
    // Disable button and show loading
    button.disabled = true;
    button.textContent = 'Claiming...';
    
    const formData = new FormData();
    formData.append('action', 'gdcm_claim_coupon');
    formData.append('nonce', gdcm_members_ajax.nonce);
    
    fetch(gdcm_members_ajax.ajax_url, {
        method: 'POST',
        body: formData
    })
    .then(response => response.json())
    .then(data => {
        if (data.success) {
            showDashboardMessage(gdcm_members_ajax.messages.coupon_claimed, 'success');
            
            // Update the coupon UI immediately instead of reloading dashboard
            updateCouponsDisplay(data.data);
            
        } else {
            showDashboardMessage(data.data || gdcm_members_ajax.messages.coupon_error, 'error');
        }
    })
    .catch(error => {
        console.error('Claim coupon error:', error);
        showDashboardMessage(gdcm_members_ajax.messages.coupon_error, 'error');
    })
    .finally(() => {
        button.disabled = false;
        button.textContent = originalText;
    });
}

function validatePasswordMatch() {
    const password = document.getElementById('register-password');
    const confirmPassword = document.getElementById('register-confirm-password');
    const submitBtn = document.querySelector('#gdcm-register-form button[type="submit"]');
    
    if (!password || !confirmPassword || !submitBtn) return;
    
    if (password.value && confirmPassword.value) {
        if (password.value !== confirmPassword.value) {
            confirmPassword.classList.add('error');
            submitBtn.disabled = true;
        } else {
            confirmPassword.classList.remove('error');
            submitBtn.disabled = false;
        }
    } else {
        confirmPassword.classList.remove('error');
        submitBtn.disabled = false;
    }
}

function showMessage(message, type) {
    // Remove any existing messages
    const existingMessages = document.querySelectorAll('.gdcm-message');
    existingMessages.forEach(msg => msg.remove());
    
    // Ensure message is a string
    let displayMessage = message;
    if (typeof message === 'object') {
        displayMessage = message.message || JSON.stringify(message);
    }
    
    // Create message element
    const messageEl = document.createElement('div');
    messageEl.className = `gdcm-message ${type}`;
    messageEl.textContent = displayMessage;
    
    // Insert after the active tab content
    const activeTabContent = document.querySelector('.gdcm-tab-content.active');
    if (activeTabContent) {
        activeTabContent.appendChild(messageEl);
        
        // Auto-hide success messages
        if (type === 'success') {
            setTimeout(() => {
                if (messageEl.parentNode) {
                    messageEl.remove();
                }
            }, 5000);
        }
    }
}

function showDashboardMessage(message, type) {
    const messageEl = document.getElementById('gdcm-dashboard-message');
    if (messageEl) {
        // Ensure message is a string
        let displayMessage = message;
        if (typeof message === 'object') {
            displayMessage = message.message || JSON.stringify(message);
        }
        
        messageEl.textContent = displayMessage;
        messageEl.className = `gdcm-message ${type}`;
        messageEl.style.display = 'block';
        
        // Auto-hide success messages
        if (type === 'success') {
            setTimeout(() => {
                messageEl.style.display = 'none';
            }, 5000);
        }
    }
}

// Email validation
function isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
}

// Phone number formatting (optional enhancement)
function formatPhoneNumber(phone) {
    // Remove all non-digit characters
    const cleaned = phone.replace(/\D/g, '');
    
    // Format as (XXX) XXX-XXXX for US numbers
    if (cleaned.length === 10) {
        return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
    }
    
    return phone; // Return original if not 10 digits
}

function loadMemberDashboard() {
    const formData = new FormData();
    formData.append('action', 'gdcm_get_member_dashboard');
    formData.append('nonce', gdcm_members_ajax.nonce);
    
    fetch(gdcm_members_ajax.ajax_url, {
        method: 'POST',
        body: formData
    })
    .then(response => response.json())
    .then(data => {
        if (data.success) {
            // Replace the entire members container content
            const membersContainer = document.querySelector('.gdcm-members-container');
            if (membersContainer) {
                // Get the HTML from the correct property
                const dashboardHTML = data.data.html || data.data;
                
                // Create a temporary container to parse the HTML
                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = dashboardHTML;
                
                // Replace the content with fade effect
                membersContainer.style.opacity = '0.5';
                
                setTimeout(() => {
                    membersContainer.innerHTML = tempDiv.innerHTML;
                    membersContainer.style.opacity = '1';
                    
                    // Re-initialize event listeners for the new content
                    initMembersArea();
                }, 300);
            }
        } else {
            console.error('Failed to load member dashboard:', data);
            // Show error message to user
            let errorMessage = 'Failed to load dashboard. Please refresh the page.';
            if (data.data && typeof data.data === 'string') {
                errorMessage = data.data;
            }
            showMessage(errorMessage, 'error');
        }
    })
    .catch(error => {
        console.error('Dashboard loading error:', error);
    });
}

function updateCouponsDisplay(responseData) {
    // Guard against undefined responseData
    if (!responseData) {
        console.warn('updateCouponsDisplay called without data');
        return;
    }
    
    // Update progress bar
    const progressFill = document.querySelector('.gdcm-progress-fill');
    if (progressFill && responseData.updated_stats) {
        progressFill.style.width = responseData.updated_stats.progress_percentage + '%';
    }
    
    // Update progress text
    const progressText = document.querySelector('.gdcm-coupon-progress p');
    if (progressText && responseData.updated_stats) {
        progressText.textContent = `${responseData.updated_stats.booking_count_progress} of ${responseData.updated_stats.coupon_frequency} bookings completed`;
    }
    
    // Update/hide claim button section
    const claimableSection = document.querySelector('.gdcm-claimable-coupons');
    if (claimableSection && responseData.updated_stats) {
        if (responseData.updated_stats.claimable_coupons > 0) {
            const claimableText = claimableSection.querySelector('p');
            if (claimableText) {
                claimableText.textContent = `You have ${responseData.updated_stats.claimable_coupons} coupon(s) available to claim!`;
            }
        } else {
            // Hide the claimable section if no more coupons available
            claimableSection.style.display = 'none';
        }
    }
    
    // Update coupons list
    if (responseData.all_coupons && responseData.all_coupons.length > 0) {
        let couponsContainer = document.querySelector('.gdcm-member-coupons');
        
        // If container doesn't exist, create it
        if (!couponsContainer) {
            const couponsTab = document.getElementById('gdcm-tab-coupons');
            if (couponsTab) {
                couponsContainer = document.createElement('div');
                couponsContainer.className = 'gdcm-member-coupons';
                couponsTab.appendChild(couponsContainer);
            }
        }
        
        if (couponsContainer) {
            // Generate the coupons HTML
            let couponsHTML = '<h4>Your Coupons</h4>';
            responseData.all_coupons.forEach(coupon => {
                const isUsed = coupon.is_used == 1;
                const statusClass = isUsed ? 'used' : 'available';
                const statusText = isUsed ? 'Used' : 'Available';
                
                couponsHTML += `
                    <div class="gdcm-coupon-item ${statusClass}" data-coupon-code="${coupon.coupon_code}">
                        <div class="gdcm-coupon-code">${coupon.coupon_code}</div>
                        <div class="gdcm-coupon-value">
                            ${coupon.discount_percentage > 0 ? 
                                `${coupon.discount_percentage}% off` : 
                                `$${parseFloat(coupon.discount_amount || 0).toFixed(2)} off`
                            }
                        </div>
                        <div class="gdcm-coupon-status">${statusText}</div>
                    </div>
                `;
            });
            
            couponsContainer.innerHTML = couponsHTML;
        }
    }
    
    // Add a subtle animation to highlight the new coupon
    if (responseData.new_coupon) {
        setTimeout(() => {
            const allCouponElements = document.querySelectorAll('.gdcm-coupon-item');
            allCouponElements.forEach(element => {
                const couponCode = element.getAttribute('data-coupon-code');
                if (couponCode === responseData.new_coupon.coupon_code) {
                    element.classList.add('gdcm-new-coupon-highlight');
                    // Scroll the new coupon into view
                    element.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
                    
                    // Remove highlight after animation
                    setTimeout(() => {
                        element.classList.remove('gdcm-new-coupon-highlight');
                    }, 3000);
                }
            });
        }, 200);
    }
}

/**
 * Initialize Entry Waiver Form and Signature Pad
 */
function initWaiverForm() {
    const canvas = document.getElementById('gdcm-signature-canvas');
    const waiverForm = document.getElementById('gdcm-entry-waiver-form');
    const clearButton = document.getElementById('gdcm-clear-signature');
    
    if (!canvas) return;
    
    // Initialize signature pad
    initSignaturePad(canvas);
    
    // Clear signature button handler
    if (clearButton) {
        clearButton.addEventListener('click', function() {
            if (signaturePad) {
                signaturePad.clear();
            }
        });
    }
    
    // Form submission handler
    if (waiverForm) {
        waiverForm.addEventListener('submit', handleWaiverSubmit);
    }
    
    // Handle window resize for canvas
    window.addEventListener('resize', resizeSignatureCanvas);
}

/**
 * Initialize the signature pad on a canvas element
 */
function initSignaturePad(canvas) {
    // Set canvas size based on container
    resizeSignatureCanvas();
    
    signaturePad = new SignaturePad(canvas, {
        backgroundColor: 'rgb(255, 255, 255)',
        penColor: 'rgb(0, 0, 0)',
        minWidth: 0.5,
        maxWidth: 2.5,
        throttle: 16,
        velocityFilterWeight: 0.7
    });
    
    // Make canvas drawing work well on all devices
    canvas.addEventListener('touchstart', function(e) {
        e.preventDefault();
    }, { passive: false });
}

/**
 * Resize signature canvas to fit container
 * Uses CSS dimensions directly to ensure proper coordinate alignment
 */
function resizeSignatureCanvas() {
    const canvas = document.getElementById('gdcm-signature-canvas');
    if (!canvas) return;
    
    const container = canvas.parentElement;
    
    // Get container's computed style to account for borders
    const containerStyle = window.getComputedStyle(container);
    const borderLeft = parseFloat(containerStyle.borderLeftWidth) || 0;
    const borderRight = parseFloat(containerStyle.borderRightWidth) || 0;
    const paddingLeft = parseFloat(containerStyle.paddingLeft) || 0;
    const paddingRight = parseFloat(containerStyle.paddingRight) || 0;
    
    // Calculate available width inside the container
    const containerRect = container.getBoundingClientRect();
    const width = Math.floor(containerRect.width - borderLeft - borderRight - paddingLeft - paddingRight);
    const height = 200; // Fixed height for signature area
    
    // Save current signature data if exists
    let signatureData = null;
    if (signaturePad && !signaturePad.isEmpty()) {
        signatureData = signaturePad.toData();
    }
    
    // Set canvas dimensions to match available space exactly
    // IMPORTANT: canvas.width/height = actual drawing resolution
    // canvas.style.width/height = CSS display size
    // They MUST match for proper coordinate alignment
    canvas.width = width;
    canvas.height = height;
    canvas.style.width = width + 'px';
    canvas.style.height = height + 'px';
    
    // Clear and reinitialize SignaturePad after resize
    if (signaturePad) {
        signaturePad.clear();
        // Restore signature data if it existed
        if (signatureData) {
            signaturePad.fromData(signatureData);
        }
    }
}

/**
 * Handle waiver form submission
 */
function handleWaiverSubmit(e) {
    e.preventDefault();
    
    const form = e.target;
    const submitBtn = form.querySelector('button[type="submit"]');
    const originalText = submitBtn.textContent;
    
    // Validate signature
    if (!signaturePad || signaturePad.isEmpty()) {
        showDashboardMessage('Please provide your signature.', 'error');
        return;
    }
    
    // Validate agreement checkbox
    const agreementCheckbox = form.querySelector('#waiver-agreement');
    if (!agreementCheckbox || !agreementCheckbox.checked) {
        showDashboardMessage('Please agree to the terms and conditions.', 'error');
        return;
    }
    
    // Disable form and show loading
    submitBtn.disabled = true;
    submitBtn.textContent = 'Submitting...';
    
    // Get signature as base64 PNG
    const signatureData = signaturePad.toDataURL('image/png');
    
    // Prepare form data
    const formData = new FormData();
    formData.append('action', 'gdcm_save_entry_waiver');
    formData.append('nonce', gdcm_members_ajax.nonce);
    formData.append('participant_first_name', form.querySelector('#waiver-participant-first-name').value);
    formData.append('participant_last_name', form.querySelector('#waiver-participant-last-name').value);
    formData.append('parent_carer_name', form.querySelector('#waiver-parent-carer-name').value);
    formData.append('mobile_number', form.querySelector('#waiver-mobile-number').value || '');
    formData.append('email', form.querySelector('#waiver-email').value);
    formData.append('company_name', form.querySelector('#waiver-company-name').value || '');
    formData.append('signature_data', signatureData);
    
    fetch(gdcm_members_ajax.ajax_url, {
        method: 'POST',
        body: formData
    })
    .then(response => response.json())
    .then(data => {
        if (data.success) {
            showDashboardMessage(data.data.message, 'success');
            
            // Clear signature
            if (signaturePad) {
                signaturePad.clear();
            }
            
            // Uncheck agreement
            if (agreementCheckbox) {
                agreementCheckbox.checked = false;
            }
            
            // Reload the dashboard to show updated waiver status
            setTimeout(() => {
                loadMemberDashboard();
            }, 2000);
        } else {
            showDashboardMessage(data.data || 'Failed to submit waiver.', 'error');
        }
    })
    .catch(error => {
        console.error('Waiver submission error:', error);
        showDashboardMessage('Error submitting waiver. Please try again.', 'error');
    })
    .finally(() => {
        submitBtn.disabled = false;
        submitBtn.textContent = originalText;
    });
}

// Make functions available globally for debugging
window.GDCMMembers = {
    switchTab,
    switchDashboardTab,
    loadMemberDashboard,
    updateCouponsDisplay,
    showMessage,
    showDashboardMessage,
    isValidEmail,
    formatPhoneNumber,
    initWaiverForm,
    initSignaturePad,
    handleWaiverSubmit,
    resizeSignatureCanvas
};

})(); // End IIFE
